import { getCachedSurvey } from "../databaseService/databaseService";
import { englishQuestions } from "../../json/English/Questions/survey-questions";
export function  questionFactory(id:number) {
  
  let questions = getCachedSurvey(id)?.questions?.["survey-questions"];
    return questions;
}

export function LDRTableFactory(id: number) {
  let LDRTable = getCachedSurvey(id)?.["results-table"]?.LDRTable;
  if (!LDRTable) {
    return [];
  }
    return LDRTable;
}
export function componentsNamesFactoryForTitle(
  id: string|number,
  component: componentNameType
) {
    let componentsNames = getCachedSurvey(id)?.components;
    if (!componentsNames) {
      return "";
    }
    return componentsNames[component]
}

export function perspectiveQuestionsFactory(
  id: string|number,
  questionNumber: perspectiveQuestionNumberType
) {
  let perspectiveQuestions = getCachedSurvey(id)?.questions?.["perspective-questions"];
  if (!perspectiveQuestions) {
    return {
      title: "",
      question: "",
    };
  }
    return perspectiveQuestions[questionNumber];
}

export function multiTypeDescriptionsMarkDownFactory(
  id: number,
  multiType: multiTypeDescriptionType
) {
  let multiTypeDescriptionsMarkDown = getCachedSurvey(id)?.["multilingualism-type-descriptions"];
  if (!multiTypeDescriptionsMarkDown) {
    return "";
  }
    return multiTypeDescriptionsMarkDown[multiType];
}

export function LDRTableExplanationFactory(id: number) {
  let LDRTableExplanation = getCachedSurvey(id)?.["results-table"]?.LDRTableExplanation;
  if (!LDRTableExplanation) {
    return "";
  }
    return LDRTableExplanation;
}

export function modalNamesFactory(
  id: number,
  modalName: modalNameType
): string {
  let modalNames = getCachedSurvey(id)?.modal;
  if (!modalNames) {
    return "";
  }
    return modalNames[modalName];
}

export function subtileHeaderFactory(lang: string) {
  switch (lang) {
    case "English":
      return null;
    case "French":
      return null;
    case "Indonesian":
      return "Diskusi MultiBahasa";
    case "Spanish":
      return "Herramienta de Evaluación del Multilingüismo";
    default:
      return null;
  }
}


// types for above functions
export type componentNameType =
""
  | "Complete"
  | "Your Multilingualism Type"
  | "Total Answers"
  | "Multilingualism Type"
  | "Limited"
  | "Shifting"
  | "Shifted"
  | "Widespread"
  | "Go Back"
  | "Start"
  | "End"
  | "Reset"
  | "Personal Copy"
  | "Send"
  | "Translation Recommendations"
  | "Extra Questions"
  | "More Info"
  | "Additional Info"
  | "Close"
  | "Previous"
  | "Next";
export type nameType =

  | "Limited"
  | "Shifting"
  | "Shifted"
  | "Widespread"
 ;

export type perspectiveQuestionNumberType = 1 | 2 | 3 | 4 | 5;

export type multiTypeDescriptionType =
  | "limited"
  | "shifting"
  | "shifted"
  | "widespread";

export type modalNameType =
  | "Reset Survey"
  | "resetInstructions"
  | "Reset/End Survey"
  | "Cancel"
  | "Send us data"
  | "submitInstructions"
  | "Send Survey"
  | "Failed to send"
  | "failedInstructions"
  | "Success"
  | "successInstructions"
  | "ok"
  | "Personal Copy";
  